import { render, staticRenderFns } from "./SurveyResultUser.vue?vue&type=template&id=54508722&scoped=true"
import script from "./SurveyResultUser.vue?vue&type=script&lang=js"
export * from "./SurveyResultUser.vue?vue&type=script&lang=js"
import style0 from "./SurveyResultUser.vue?vue&type=style&index=0&id=54508722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54508722",
  null
  
)

export default component.exports